<mat-card appearance="filled" class="container mat-elevation-z8" fxFlex="100%">
  <mat-card-title fxLayout="row" fxLayoutAlign="start center">
    <span class="header-text">{{ titleService.getBaseTitle() }}</span>
  </mat-card-title>

  <mat-card-content>
    <form [formGroup]="dataTable.filter" fxLayout="row wrap" fxLayoutGap="10px">
      <mat-form-field color="accent" appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search Stores</mat-label>
        <input matInput formControlName="filter">
        <mat-icon matSuffix>search</mat-icon>
      </mat-form-field>
    </form>

    <mat-table #table [dataSource]="dataTable" matSort matSortActive="name" matSortDirection="asc" matSortDisableClear>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Name</mat-header-cell>
        <mat-cell *matCellDef="let store">
          <a routerLink="/stores/{{store.id}}" class="clickable">{{store.name}} </a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="clientStoreId">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Client Store ID</mat-header-cell>
        <mat-cell *matCellDef="let store"> {{store.clientStoreId}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="organization.name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Organization</mat-header-cell>
        <mat-cell *matCellDef="let store"> {{store.organization?.name}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="city">
        <mat-header-cell *matHeaderCellDef mat-sort-header> City</mat-header-cell>
        <mat-cell *matCellDef="let store"> {{store.city}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="state">
        <mat-header-cell *matHeaderCellDef mat-sort-header> State</mat-header-cell>
        <mat-cell *matCellDef="let store"> {{store.state}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="solutions">
        <mat-header-cell *matHeaderCellDef> Solutions</mat-header-cell>
        <mat-cell *matCellDef="let store"> {{store.solutions | solution}} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="dataTable.displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: dataTable.displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator [pageSize]="50" [pageSizeOptions]="[25, 50, 100, 250]" showFirstLastButtons></mat-paginator>
  </mat-card-content>
</mat-card>

